import React, { useMemo } from 'react';
import clsx from 'clsx';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { useTranslation } from 'react-i18next';
import { ResponsiveRcSlider } from 'components/responsive-rc-slider/slider';
import { Checkbox } from '../checkbox';


export interface IPowersFilter {
    filter: any;
    onFilterChange: (filterId: number, value: any, debounced?: boolean) => void;
    className?: string;
    minValue?: number;
    steps: [number, number, number]
}

export const PowersFilter: React.FC<IPowersFilter> = (props): JSX.Element => {
    const {
        filter, onFilterChange, className, minValue, steps
    } = props;
    const { t } = useTranslation();
    const handleChange = (type: string, value) => {
        const { value: _value } = filter;
        if (type === 'power') {
            _value[0] = value;
        } else if (type === 'dist') {
            _value[1] = value > 0 ? value : 1;
        } else {
            _value[2] = value;
        }
        onFilterChange(
            filter.id,
            _value,
            true
        );
    };

    const maxPower = useMemo(() => {
        if (Number.isFinite(filter.settingsFilter.maxPower) && !!filter.settingsFilter.maxPower) {
            return filter.settingsFilter.maxPower;
        }
        return 100;
    }, [ filter.settingsFilter.maxPower ]);

    const _value = filter.value !== null ? filter.value : filter.values;
    const units = filter.settingsFilter?.units;

    return (
        <div className={clsx('objects-filter', 'objects-filter-powers', className)}>
            <div className="objects-filter__name">
                <Checkbox
                    checked={_value[2]}
                    onChange={() => handleChange('enabled', !_value[2])}
                />
                {filter.name}
            </div>
            <div className={clsx('objects-filter-powers__wrapper', !_value[2] && 'disabled')}>
                <div style={{ marginTop: 4 }}>
                    <div className="objects-filter-powers__control">
                        {/* <div className="objects-filter__name">
                            {t('POWER_FILTER_LABEL_DISTANCE') }
                        </div> */}
                        <ResponsiveRcSlider
                            className="range-filter-control"
                            value={_value[1] > 1 ? _value[1] : 0}
                            min={steps[0]}
                            max={steps[steps.length - 1]}
                            step={null}
                            marks={{ [steps[0]]: '', [steps[1]]: '', [steps[2]]: '' }}
                            onChange={e => handleChange('dist', e)}
                        />
                    </div>
                    <div className="objects-filter-powers__values">
                        {t('POWER_FILTER_VALUE', {
                            distance: _value[1] > 0 ? _value[1] : 1,
                            units: t(units.distance)
                        }) }
                    </div>
                </div>
                <div style={{ marginTop: 28 }}>
                    <div className="objects-filter-powers__control">
                        <div className="objects-filter__name">
                            {`${filter.type === 'powers'
                                ? t('POWER_FILTER_LABEL_FREE_POWER')
                                : t('POWER_FILTER_FREE_BANDWIDTH')}${units.power ? `, ${t(units.power)}` : ''}`}
                        </div>
                        <ResponsiveRcSlider
                            className="range-filter-control"
                            value={_value[0]}
                            min={typeof minValue === 'number' ? minValue : 1}
                            max={maxPower}
                            step={0.5}
                            onChange={e => handleChange('power', e)}
                        />
                    </div>
                    <div className="objects-filter-powers__values">
                        <span>{_value[0]}</span>
                        <span />
                        <span />
                    </div>
                </div>
            </div>
        </div>
    );
};
